import axios from "axios";
import status from "./http-status";
// import "./axios";
import Vue from "vue";
// 引入环境地址接口
import checkDevice from "../tools/app";
// 全局的axios默认值
// axios.defaults.baseURL = BASE_URL;
// axios.defaults.baseURL = `http://appxtest.xiaoyu.top:8080/enterprise`;

axios.defaults.baseURL = `https://appx.xiaoyu.top/enterprise`;
// 将axios放到vue的原型上直接调用$post
Vue.prototype.$post = axios;
// 请求拦截器
axios.interceptors.request.use(
  function (config) {
    config.timeout = 30000;
    // 测试环境
    // config.headers.Authorization = sessionStorage.getItem("CONFIDENTIAL");
    // console.log(config.headers.Authorization,'1111')
    // // 开发环境
    //本地环境
    // config.headers.Authorization =
    //   "A031BF11-E7D0-490F-8568-BE4908091983_XY1000001292399539";
    config.params = {
      ...(config.params || {}),
      _t: +new Date(),
      //本地环境
      // userId: "XY1000001292399539",
    };

    return config;
  },

  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    let data = response.data;
    
    // 如果响应数据为空或不是对象，直接返回
    if (!data || typeof data !== 'object') {
      return data;
    }
    
    let phone = checkDevice();
    // 时间 - 需要先检查 data.data 是否存在
    let offlineTime = data.data && data.data.offlineTime;
    if (data.retCode == 500103 && phone == "android") {
      window.jsCallAndroid.jsCallOfflineFunction(offlineTime);
    } else if (data.retCode == 500103 && phone == "ios") {
      window.webkit.messageHandlers.SignOut.postMessage(offlineTime);
    }
    
    // 如果没有 retCode 属性，直接返回（可能是其他格式的响应）
    if (!data.hasOwnProperty("retCode")) {
      return data;
    }
    
    // 如果没有 code 属性，检查 retCode 是否为成功状态
    if (!data.hasOwnProperty("code")) {
      // 支持多种成功状态码：0, -1, 200
      if (data.retCode === 0 || data.retCode === -1 || data.retCode === 200) {
        return data;
      }
    } else {
      // 如果有 code 属性，检查 retCode 是否为成功状态
      // 支持多种成功状态码：0, -1, 200
      if (data.retCode === 0 || data.retCode === -1 || data.retCode === 200) {
        return data;
      }
    }
    
    // 其他状态码视为错误
    const error = new Error(response.data.message || "请求失败");
    // 对请求错误做统一提示
    if (Vue.prototype.$Message) {
      Vue.prototype.$Message.warning(error.message);
    }
    error.data = data;
    error.response = response;
    throw error;
  },
  function (error) {
    // 对响应错误做点什么
    if (error && error.response) {
      error.message = status(error);
    } else if (error && error.message) {
      // 网络错误或其他错误
      console.error("请求错误:", error.message);
    }
    return Promise.reject(error);
  }
);
